import * as Footer_en from './Footer.en.js';
import * as Footer_es from './Footer.es.js';

const FooterTuple = [
  { type: 'Footer', language: 'en', object: Footer_en.default },
  { type: 'Footer', language: 'es', object: Footer_es.default },
];

export default FooterTuple;
